import {Component, OnInit, ViewChild} from '@angular/core';
import {BreadcrumbMktComponent} from "../breadcrumb-mkt/breadcrumb-mkt.component";
import {Apollo} from "apollo-angular";
import {GETALLUSERSMONGO, REGISTERUSERMKT, GETUSERMKTBYID, UPDATEUSERMKT} from "../../../graphql/graphql.queris";
import {AuthService} from "../../../auth/auth.service";
import {NgClass, NgForOf, NgOptimizedImage} from "@angular/common";
import {RouterLink} from "@angular/router";
import {FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {closeModal, mostrarToast} from "../../../utils/utilities";
import {ServiceNotificationService} from "../../../services/service-notification.service";
import {NotificationsComponent} from "../../../notifications/notifications.component";

@Component({
  selector: 'app-usuarios',
  standalone: true,
  imports: [
    BreadcrumbMktComponent,
    NgForOf,
    RouterLink,
    NgClass,
    NgOptimizedImage,
    ReactiveFormsModule,
    NotificationsComponent
  ],
  templateUrl: './usuarios.component.html',
  styleUrl: './usuarios.component.css'
})
export class UsuariosComponent implements OnInit {
  @ViewChild('addUserForm') addUserForm: any;
  @ViewChild('editUserForm') editUserForm: any;
  title = 'Usuarios Marketing';
  route = '/dashboardmkt/usuariosmkt';
  usuarios: any[] = [];
  formAddUser: FormGroup = new FormGroup({});
  formEditUser: FormGroup = new FormGroup({});
  roles: any[] = []
  rolesUser: any[] = [];
  idUser: string = '';

  constructor(
    private apollo: Apollo,
    private authService: AuthService,
    private fb: FormBuilder,
    private serviceNotification: ServiceNotificationService

) {
  }

  ngOnInit(): void {
    this.getAllUsers();

    this.formAddUser = this.fb.group({
      email: ['', [Validators.required]],
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
      status: ['', [Validators.required]],
      roles: this.fb.array([]),
    });


    this.formEditUser = this.fb.group({
      email: ['', [Validators.required]],
      username: ['', [Validators.required]],
      // password: [''],
      status: ['', [Validators.required]],
      roles: this.fb.array([]),
    });


  }

  onCheckboxAddChange(event: any) {
    const rolesArray: FormArray = this.formAddUser.get('roles') as FormArray;

    if (event.target.checked) {
      rolesArray.push(new FormControl(event.target.value));
    } else {
      const index = rolesArray.controls.findIndex(x => x.value === event.target.value);
      if (index !== -1) {
        rolesArray.removeAt(index);
      }
    }
  }
  onCheckboxEditChange(event: any) {
    const rolesArray: FormArray = this.formEditUser.get('roles') as FormArray;

    if (event.target.checked) {
      rolesArray.push(new FormControl(event.target.value));
    } else {
      const index = rolesArray.controls.findIndex(x => x.value === event.target.value);
      if (index !== -1) {
        rolesArray.removeAt(index);
      }
    }
  }

  sendAllData() {

    const formValue = {
      ...this.formAddUser.value,
      status: this.formAddUser.value.status === 'true'
    }
    this.registerUser(formValue);
  }


    getAllUsers() {
    const token = this.authService.getToken();
    this.apollo.query({
      query: GETALLUSERSMONGO,
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      fetchPolicy: 'network-only'
    }).subscribe((result: any) => {
      this.usuarios = result.data.getAllUsersMkt;
    });
  }

  registerUser(input: any) {
    const token = this.authService.getToken();
    this.apollo.mutate({
      mutation: REGISTERUSERMKT,
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      variables: {input: input}
    }).subscribe((result: any) => {
      this.getAllUsers();
      this.formAddUser.reset();
      closeModal(this.addUserForm);
      mostrarToast('Usuario registrado correctamente', true, this.serviceNotification);
    }, error => {
      console.log(error);
      mostrarToast('Ha ocurrido un error inesperado', false, this.serviceNotification);
    });
  }

  editUser(id: string ,input: any) {
    const token = this.authService.getToken();
    this.apollo.mutate({
      mutation: UPDATEUSERMKT,
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      variables: {id: id, input: input}
    }).subscribe((result: any) => {
      this.getAllUsers();
      this.formEditUser.reset();
      closeModal(this.editUserForm);
      mostrarToast('Usuario actualizado correctamente', true, this.serviceNotification);
    }, error => {
      console.log(error);
      mostrarToast('Ha ocurrido un error inesperado', false, this.serviceNotification);
    });
  }


  getUserById(id: string) {
    this.idUser = id;
    const token = this.authService.getToken();
    this.apollo.query({
      query: GETUSERMKTBYID,
      context: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      fetchPolicy: 'network-only',
      variables: {id: id}
    }).subscribe((result: any) => {
      const dataUser = result.data.getUserMktByID;
      this.formEditUser.patchValue({
        email: dataUser.email,
        username: dataUser.username,
        status: dataUser.status,
        roles: dataUser.roles,
      });
  })
  }


  edit(item: any) {
    this.getUserById(item)
  }



  delete(item: any) {
    alert(item)
  }

  editAllData() {
    const formValue = {
      ...this.formEditUser.value,
      status: this.formEditUser.value.status === 'true'
    }
    this.editUser(this.idUser, formValue);



  }
}


